<template>
    <div class="home">
        <v-container fill-height class="pt-0">
            <h2 class="mb-3">Auto Removed History</h2>

            <report-filter :show-operator-filter="false"
                           ref="reportFilter"
                           :show-site-filter="false"
                           :report-filter-override="reportFilterOverride"
                           :show-incident-type-filter="false"></report-filter>


            <v-row>
                <v-col>
                    <v-text-field v-model="searchText"
                                  append-icon="mdi-magnify"
                                  label="Search"
                                  single-line
                                  class="mb-3"
                                  hide-details></v-text-field>
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <v-data-table :headers="headers"
                                  :items="autoRemovedItems"
                                  must-sort
                                  :sort-by.sync="sortBy"
                                  :sort-desc.sync="sortDesc"
                                  :server-items-length="totalItems"
                                  :footer-props="{'items-per-page-options': [15, 50, 100, 100, 1000]}"
                                  :loading="isBusy"
                                  :items-per-page.sync="pageSize"
                                  :page.sync="pageNo"
                                  class="elevation-1">

                        <template v-slot:item.incident="{ item }">
                            <v-btn color="primary"
                                   plain
                                   class="ma-0 pa-0"
                                   @click="onNavigateHighSevDetails(item.incident)">
                                {{ item.incident }}
                            </v-btn>
                            <div v-if="item.severity">
                                <v-chip x-small class="mb-3">
                                    {{ item.severity }}
                                </v-chip>
                            </div>
                        </template>

                        <template v-slot:item.logged="{ item }">
                            {{ item.logged | DateTime }}
                        </template>

                        <template v-slot:item.affectedOperator="{ item }">
                            <v-chip class="ma-1" :key="operator" small v-for="operator in onGetAffectedOperatorArray(item.affectedOperator)" @click="onClickOperatorName(operator)">
                                {{ operator }}
                            </v-chip>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>



        </v-container>
    </div>
</template>

<script>
    import ReportFilter from "../../components/reports/ReportFilter"
    import reportService from "../../services/reportService";
    import moment from 'moment';

    export default {
        name: 'AutoRemovedHistory',
        data: function () {
            return {
                isBusy: true,
                accessToken: null,
                searchTimer: null,
                searchText: "",
                pageNo: 1,
                pageSize: 10,
                totalItems: 0,
                sortBy: 'incident',
                sortDesc: false,
                reportFilterOverride: {
                    reportDateType: 0,
                    startDate: moment().subtract(7, "days").format(moment.HTML5_FMT.DATE),
                    startTime: "06:00",
                    endDate: moment().format(moment.HTML5_FMT.DATE),
                    endTime: "06:00",
                    selectedOperatorBrands: [],
                    selectedIncidentTypes: [],
                    selectedSites: [],
                    selectedResponsibleTeams: [],
                    startDateAndTime: null,
                    endDateAndTIme: null,
                    name: ""
                },
                autoRemovedItems: [],
                headers: [
                    {
                        text: 'Incident',
                        align: 'start',
                        sortable: true,
                        value: 'incident',
                    },
                    {
                        text: 'Date Of Incident',
                        align: 'start',
                        sortable: true,
                        value: 'logged',
                    },
                    {
                        text: 'Title',
                        align: 'start',
                        sortable: true,
                        value: 'title',
                    },
                    {
                        text: 'Affected Operator',
                        align: 'start',
                        sortable: true,
                        value: 'affectedOperator',
                    },
                    {
                        text: 'Customer Perspective',
                        align: 'start',
                        sortable: true,
                        value: 'customerPerspective',
                    },
                    {
                        text: 'Root Cause',
                        align: 'start',
                        sortable: true,
                        value: 'rootCause',
                    },
                    {
                        text: 'Assigned Team',
                        align: 'start',
                        sortable: true,
                        value: 'assignedTeam',
                    },
                    {
                        text: 'SME\' TTr',
                        align: 'start',
                        sortable: true,
                        value: 'SmeTtr',
                    },
                    {
                        text: 'Assignee',
                        align: 'start',
                        sortable: true,
                        value: 'assignee',
                    },
                    {
                        text: 'Sign Off',
                        align: 'start',
                        sortable: true,
                        value: 'signOff',
                    },
                    {
                        text: 'Pbi Number',
                        align: 'start',
                        sortable: true,
                        value: 'pbiNumber',
                    }
                ],
            }
        },
        components: {
            ReportFilter
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();

                await this.searchAutoRemovedHistory();
            },
            async searchAutoRemovedHistory() {
                this.isBusy = true;

                var sortBy = this.sortBy === null ? "Incident" : this.sortBy;
                var sortDesc = this.sortDesc === null || this.sortDesc === false ? "DESCENDING" : "ASCENDING"
                this.loading = true;

                let pageSize = this.pageSize;

                if (pageSize === -1) {
                    pageSize = 2000;
                }

                let startDate = moment.utc(`${this.reportFilterOverride.startDate} ${this.reportFilterOverride.startTime}`).format('YYYY MM DD h:mm:ss');
                let endDate = moment.utc(`${this.reportFilterOverride.endDate} ${this.reportFilterOverride.endTime}`).format('YYYY MM DD h:mm:ss');

                const result = await reportService.searchAutoRemovedHistory(this.accessToken, this.searchText, this.pageNo, pageSize, sortBy, sortDesc, startDate, endDate);

                if (result) {

                    this.totalItems = result.count;
                    this.autoRemovedItems = result.data;
                }

                this.isBusy = false;
            },
            onGetAffectedOperatorArray(affectedOperator) {
                if (!affectedOperator) return [];
                return affectedOperator.replace(/[\[\]\"]/g, "").split(',').filter(operator => operator !== ""); //eslint-disable-line
            },
            onNavigateHighSevDetails(incidentId) {
                let routeData = this.$router.resolve({ name: 'HighSevDetails', params: { id: incidentId } });
                window.open(routeData.href, '_blank');
            },
        },
        created() {
            this.setup();
        },
        watch: {
            deep: true,
            immediate: true,
            reportFilterOverride: {
                handler() {
                    this.searchAutoRemovedHistory();
                },
                deep: true
            },
            pageNo: function () {
                this.searchAutoRemovedHistory();
            },
            pageSize: function () {
                this.searchAutoRemovedHistory();
            },
            searchText: function () {
                let self = this;
                clearTimeout(this.searchTimer);
                this.searchTimer = setTimeout(function () {
                    self.pageNo = 1;
                    self.searchAutoRemovedHistory();
                }, 1000);
            },
            sortBy: function () {
                this.searchAutoRemovedHistory();
            },
            sortDesc: function () {
                this.searchAutoRemovedHistory();
            }
        }
    }
</script>
